<template>
<div>
    <design-form ref="designFormModal"></design-form>
    <b-row>
        <b-col class="col-md-2">
            <label style="font-size: x-small;" for="start-date-input">{{ $t('designRenewalReport.renewal_date_start') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" v-model="startDate"></CustomDatePicker>
        </b-col>
        <b-col class="col-md-2">
            <label style="font-size: x-small;" for="end-date-input">{{ $t('designRenewalReport.renewal_date_end') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" v-model="endDate"></CustomDatePicker>
        </b-col>
        <b-col class="col-md-8  mt-2 custom-search d-flex justify-content-end">
            <div class="d-flex align-items-center">
                <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getDesignRenewalReportList()" @click="getDesignRenewalReportList()">{{ $t('others.list') }}</b-button>

                <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="designRenewalReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme" @on-cell-click="onCellClick">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('designRenewalReport.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'renewalDate'" class="text-nowrap">
                {{ $t('designRenewalReport.renewal_date') }}
            </span>
            <span v-else-if="props.column.field === 'instructionDate'" class="text-nowrap">
                {{ $t('designRenewalReport.instruction_date') }}
            </span>
            <span v-else-if="props.column.field === 'reminderDate'" class="text-nowrap">
                {{ $t('designRenewalReport.reminder_date') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Agent Name -->
            <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                <b-badge @contextmenu.prevent="openContextMenu($event, props.row.designId)" variant="primary" style="cursor: pointer;">
                    <feather-icon icon="MousePointerIcon" class="mr-25" />
                    <span>{{ props.row.recordNo }}</span>
                </b-badge>
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getDesignRenewalReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            dir: false,
            startDate: null,
            endDate: null,
            columns: [{
                    label: this.$t('designRenewalReport.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('designRenewalReport.renewal_date'),
                    field: 'renewalDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('designRenewalReport.instruction_date'),
                    field: 'instructionDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('designRenewalReport.reminder_date'),
                    field: 'reminderDate',
                    formatFn: this.$formatFn
                },
                {
                    label: 'Process',
                    field: 'process',
                }
            ],
            rows: [],
            searchTerm: '',
            pageNo: 1,
            total: 0,
        }
    },
    mounted() {
        this.startDate = new Date().toJSON()
        this.endDate = new Date(new Date().setMonth(new Date().getMonth() + 6)).toJSON();
        this.getDesignRenewalReportList()

    },
    methods: {
        onCellClick(params) {
            if (params.column.field == "recordNo") {
                this.$refs.designFormModal.showInfo(params.row.designId)
            }
        },
        getDesignRenewalReportList() {
            this.rows = []
            const data = {
                renewalDateStart: this.startDate,
                renewalDateEnd: this.endDate,
                pageLength: this.pageLength,
                pageNo: this.pageNo
            }
            const controller = {
                name: 'DesignRenewal',
                actionName: 'GetDesignRenewalReportList'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.designRenewalReportList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.total = response.data.total
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
    exportExcel() {
        const controller = {
            name: 'DesignRenewal',
            actionName: 'CanExport'
        }
        const data = {
            columnList: this.columns,
            DataList: this.rows
        }
        const payload = {
            data: data,
            controller: controller
        }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.$downloadFile("Tasarım Yenileme Raporu", response.data.base64, 'xlsx')
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.recordCursor {
    cursor: pointer;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
